import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import Layout from "@/components/layout/Layout";

export default function SubscriptionPage() {
  return (
    <Layout>
      <div className="container mx-auto py-8">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold tracking-tight">Subscription Management</h1>
            <p className="text-muted-foreground">
              Manage your nursing home subscription plan and billing
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2">
            <Card>
              <CardHeader>
                <CardTitle>Current Plan</CardTitle>
                <CardDescription>Your active subscription details</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="font-medium">Plan</span>
                    <Badge variant="secondary">Basic</Badge>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="font-medium">Status</span>
                    <Badge variant="default">Active</Badge>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="font-medium">Monthly Cost</span>
                    <span>€29.00</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="font-medium">Next Billing</span>
                    <span>Jan 15, 2025</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Usage Summary</CardTitle>
                <CardDescription>Current period usage overview</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <span className="font-medium">Nursing Homes</span>
                    <span>1 / 1</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="font-medium">Media Uploads</span>
                    <span>5 / 20</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="font-medium">Profile Updates</span>
                    <span>12</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          <Card className="mt-6">
            <CardHeader>
              <CardTitle>Billing History</CardTitle>
              <CardDescription>Your recent subscription payments</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="space-y-3">
                <div className="flex items-center justify-between py-2 border-b">
                  <div>
                    <p className="font-medium">December 2024</p>
                    <p className="text-sm text-muted-foreground">Basic Plan</p>
                  </div>
                  <div className="text-right">
                    <p className="font-medium">€29.00</p>
                    <Badge variant="default" className="text-xs">Paid</Badge>
                  </div>
                </div>
                <div className="flex items-center justify-between py-2 border-b">
                  <div>
                    <p className="font-medium">November 2024</p>
                    <p className="text-sm text-muted-foreground">Basic Plan</p>
                  </div>
                  <div className="text-right">
                    <p className="font-medium">€29.00</p>
                    <Badge variant="default" className="text-xs">Paid</Badge>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="mt-6 flex gap-4">
            <Button variant="outline">Change Plan</Button>
            <Button variant="outline">Update Payment Method</Button>
            <Button variant="destructive">Cancel Subscription</Button>
          </div>
        </div>
      </div>
    </Layout>
  );
}